import type { Latest } from '@redviking/argonaut-util/types/mes/applet-designs/appletDesign.latest.zod';

export const macroInfoMap: {
    [macroTypeKey in Latest.Macros.AppletMacro['type']]: {
        title: string;
        icon: string;
    };
} = {
    materialLookup: {
        title: 'Material Lookup Table',
        icon: 'mdi-nut',
    },
};
